import moment from "moment";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { isNIF, isNIE } from "better-dni";

export const date = (value, minDate, maxDate) => {
    const m = moment(value, "YYYY/MM/DD", "es");
    return m.isValid() && m.isBetween(minDate, maxDate);
};

export const phone = (value, country) => {
    const phoneNumber = parsePhoneNumberFromString(value, country);

    if (!phoneNumber) {
        return false;
    }

    return phoneNumber.isValid();
};

export const idcard = string => isNIF(string) || isNIE(string);
